import React from "react"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <footer className="text-center container-fluid">
      &copy; HDForm by CPIA {new Date().getFullYear()} |{" "}
      <Link to="/terms-of-use#terms">Terms Of Use</Link> |{" "}
      <Link to="/policy#policy">Privacy Policy</Link>
    </footer>
  )
}

export default Footer
